import {useState} from "react";
import {uuidv4} from "../services/uuid"
import {Modal, Button} from "react-bootstrap"
import {getRandomNumber} from "../services/api";
export function Soda() {
    const [soda, setSoda] = useState()
    
    const draw = () => {
        //let random = Math.floor(Math.random() * choices.length)

        //setPicked(choices[random].name)
        setSoda('')
        getRandomNumber(5)
            .then(result => {
                console.log(result)
                if (result.number === 1) {
                    setSoda('You get a soda!')
                } else {
                    setSoda('Maybe Next Time')
                }
            })
            .catch(ex => {
                console.log("Error getting random ", ex);
            })
    }

    return (
        <>
            <div className="mt-3">
                <button type="button" className="btn btn-primary" onClick={draw}>Decide</button>
                <span className={"ms-3"}>{soda}</span>
            </div>
        </>

    )
}